// src/cases/ConfidisCaseEdit.js
import React from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  DateInput,
  NumberInput,
  SelectInput,
  BooleanInput,
  RadioButtonGroupInput,
  required,
  email,
  minValue,
} from "react-admin";
import { Grid, Typography, Divider, Box } from '@mui/material';
import AdminEditableCreditInformation from '../components/AdminEditableCreditInformation';
import MortgageFreeNotice from './MortgageFreeNotice';


const validateEmail = [required(), email()];
const validateRequired = [required()];
const validatePositiveNumber = [required(), minValue(0)];





const transformEditData = (data) => {
  const cleanData = Object.fromEntries(
    Object.entries(data).filter(([_, value]) => value !== undefined)
  );

  if (!cleanData.bankGroup || !String(cleanData.bankGroup).trim()) {
    cleanData.bankGroup = 'COFIDIS';
  }

  return cleanData;
};

// Section title component
const SectionTitle = ({ title }) => (
  <Box mt={3} mb={2}>
    <Typography variant="h6" color="primary">
      {title}
    </Typography>
    <Divider />
  </Box>
);

export const CofidisCaseEdit = (props) => {
  return (
    <Edit {...props} transform={transformEditData} mutationMode="pessimistic" redirect="show">
      <SimpleForm>
      <MortgageFreeNotice />
      {/* DATOS DEL PRIMER TITULAR (First Holder's Data) */}
      <SectionTitle title="DATOS DEL PRIMER TITULAR" />
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <TextInput source="primerTitular.nombre" label="Nombre" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextInput source="primerTitular.apellidos" label="Apellidos" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextInput source="primerTitular.dni" label="DNI" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <DateInput source="primerTitular.fechaNacimiento" label="Fecha de nacimiento" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextInput source="primerTitular.nacionalidad" label="Nacionalidad" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextInput source="primerTitular.direccionPostal" label="Dirección postal" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextInput source="primerTitular.poblacion" label="Población" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextInput source="primerTitular.provincia" label="Provincia" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextInput source="primerTitular.codigoPostal" label="Código Postal" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextInput source="primerTitular.telefonoFijo" label="Teléfono fijo" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextInput source="primerTitular.movil" label="Móvil" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextInput source="primerTitular.email" label="E-mail" fullWidth />
        </Grid>
      </Grid>

      {/* DATOS DEL SEGUNDO TITULAR (Second Holder's Data) */}
      <SectionTitle title="DATOS DEL SEGUNDO TITULAR" />
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <TextInput source="segundoTitular.nombre" label="Nombre" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextInput source="segundoTitular.apellidos" label="Apellidos" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextInput source="segundoTitular.dni" label="DNI" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <DateInput source="segundoTitular.fechaNacimiento" label="Fecha de nacimiento" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextInput source="segundoTitular.nacionalidad" label="Nacionalidad" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextInput source="segundoTitular.direccionPostal" label="Dirección postal" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextInput source="segundoTitular.poblacion" label="Población" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextInput source="segundoTitular.provincia" label="Provincia" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextInput source="segundoTitular.codigoPostal" label="Código Postal" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextInput source="segundoTitular.telefonoFijo" label="Teléfono fijo" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextInput source="segundoTitular.movil" label="Móvil" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextInput source="segundoTitular.email" label="E-mail" fullWidth />
        </Grid>
      </Grid>

      {/* DATOS PROFESIONALES (PRIMER TITULAR) */}
      <SectionTitle title="DATOS PROFESIONALES (PRIMER TITULAR)" />
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <TextInput source="primerTitular.profesion" label="Profesión" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <NumberInput 
            source="primerTitular.salarioNetoMensual" 
            label="Salario neto mensual" 
            defaultValue={0}
            fullWidth 
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <NumberInput 
            source="primerTitular.numeroPagas" 
            label="Número de pagas" 
            defaultValue={12}
            min={1}
            max={16}
            fullWidth 
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <SelectInput
            source="primerTitular.tipoContrato"
            label="Tipo de contrato"
            choices={[
              { id: 'Indefinido', name: 'Indefinido' },
              { id: 'Temporal', name: 'Temporal' },
              { id: 'Autónomo', name: 'Autónomo' },
              { id: 'Desempleado', name: 'Desempleado' },
              { id: 'Jubilado', name: 'Jubilado' },
            ]}
            defaultValue="Indefinido"
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <DateInput source="primerTitular.antiguedadLaboral" label="Antigüedad laboral" fullWidth />
        </Grid>
      </Grid>

      {/* DATOS PROFESIONALES (SEGUNDO TITULAR) */}
      <SectionTitle title="DATOS PROFESIONALES (SEGUNDO TITULAR)" />
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <TextInput source="segundoTitular.profesion" label="Profesión" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <NumberInput 
            source="segundoTitular.salarioNetoMensual" 
            label="Salario neto mensual" 
            defaultValue={0}
            fullWidth 
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <NumberInput 
            source="segundoTitular.numeroPagas" 
            label="Número de pagas" 
            defaultValue={12}
            min={1}
            max={16}
            fullWidth 
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <SelectInput
            source="segundoTitular.tipoContrato"
            label="Tipo de contrato"
            choices={[
              { id: 'Indefinido', name: 'Indefinido' },
              { id: 'Temporal', name: 'Temporal' },
              { id: 'Autónomo', name: 'Autónomo' },
              { id: 'Desempleado', name: 'Desempleado' },
              { id: 'Jubilado', name: 'Jubilado' },
            ]}
            defaultValue="Indefinido"
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <DateInput source="segundoTitular.antiguedadLaboral" label="Antigüedad laboral" fullWidth />
        </Grid>
      </Grid>

      {/* DATOS DE VIVIENDA (Housing Data) */}
      <SectionTitle title="DATOS DE VIVIENDA" />
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <RadioButtonGroupInput 
            source="gastosVivienda.tipoVivienda" 
            label="Tipo de Vivienda"
            choices={[
              { id: 'propiedadSinHipoteca', name: 'Propiedad sin hipoteca' },
              { id: 'propiedadConHipoteca', name: 'Propiedad con hipoteca' },
              { id: 'alquiler', name: 'Alquiler' },
              { id: 'otros', name: 'Otros' },
            ]}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <NumberInput 
            source="gastosVivienda.importeHipoteca" 
            label="Importe Hipoteca" 
            defaultValue={0}
            fullWidth 
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <NumberInput 
            source="gastosVivienda.importeAlquiler" 
            label="Importe Alquiler" 
            defaultValue={0}
            fullWidth 
          />
        </Grid>
      </Grid>

      {/* DATOS DE COCHE (Car Data) */}
      <SectionTitle title="DATOS DE COCHE" />
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <TextInput source="datosCoche.matricula" label="Matrícula" fullWidth />
        </Grid>
        <Grid item xs={12} md={6}>
          <NumberInput 
            source="datosCoche.kilometraje" 
            label="Kilometraje" 
            defaultValue={0}
            fullWidth 
          />
        </Grid>
      </Grid>

      {/* OTROS DATOS (Other Data) */}
      <SectionTitle title="OTROS DATOS" />
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <SelectInput
            source="otrosDatos.estadoCivil"
            label="Estado civil"
            choices={[
              { id: 'Soltero', name: 'Soltero' },
              { id: 'Casado', name: 'Casado' },
              { id: 'Divorciado', name: 'Divorciado' },
              { id: 'Viudo', name: 'Viudo' },
              { id: 'Pareja de hecho', name: 'Pareja de hecho' },
            ]}
            defaultValue="Soltero"
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <NumberInput 
            source="otrosDatos.numeroHijos" 
            label="Nº hijos a su cargo" 
            defaultValue={0}
            fullWidth 
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextInput source="otrosDatos.otrosCreditosPrestamos" label="Otros créditos/préstamos" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <NumberInput 
            source="otrosDatos.importeMensual" 
            label="Importe mensual" 
            defaultValue={0}
            fullWidth 
          />
        </Grid>
      </Grid>

      {/* Case Information Section */}
      <SectionTitle title="Información del Caso" />
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <DateInput source="registeredDate" label="Fecha de registro" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <SelectInput
            source="status"
            label="Estado"
            choices={[
              { id: 'En Revisión', name: 'En Revisión' },
              { id: 'Aprobado', name: 'Aprobado' },
              { id: 'Rechazado', name: 'Rechazado' },
            ]}
            defaultValue="En Revisión"
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextInput source="bankGroup" label="Grupo Bancario" defaultValue="COFIDIS" fullWidth />
        </Grid>
      </Grid>

      {/* Credit Information Section — always use the full admin editor so every
          credit field is editable (cofidisCases is only edited in admin view). */}
      <AdminEditableCreditInformation source="creditos" />

      {/* Notes Section */}
      <SectionTitle title="Notas" />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextInput source="note" label="Notas" multiline rows={4} fullWidth />
        </Grid>
      </Grid>
      </SimpleForm>
    </Edit>
  );
};
